import { PreferenceCenter } from "@ua/web-sdk/lib/remote-data/preference-center"
import * as React from "react"

import { PreferenceOperator } from "./EmailPreferenceCenter"
import Items from "./Items"
import SubHeader from "./SubHeader"
import LabeledSectionBreak from "./LabeledSectionBreak"

type Props = {
  section: PreferenceCenter["sections"][number]
  lastSection: boolean
} & PreferenceOperator

const Section: React.FC<Props> = ({ section, lastSection, ...rest }) => {
  const showBreak = React.useMemo(() => {
    return (
      !section.items?.some(
        (item) => item.type === "contact_subscription_group"
      ) && section.display
    )
  }, [section])
  switch (section.type) {
    case "section":
      return (
        <fieldset>
          {section.display && <SubHeader {...section.display} />}
          {showBreak && <hr />}
          <Items items={section.items} lastSection={lastSection} {...rest} />
        </fieldset>
      )
    case "labeled_section_break":
      return <LabeledSectionBreak section={section} />
  }
}

export default Section
